export enum UIGameComponentZIndex {
    Map = 0,
    Popup = 1,
    Settings = 2,
    VotePopups = 3,
}
